import React from "react";
import Button from "components/Button";

import { colors, sizes, strings } from "assets/constants";

interface AddItemButtonProps {
  width?: number;
  onPress: () => void;
  disabled?: boolean;
  title?: string;
}

export default function AddItemButton(props: AddItemButtonProps) {
  return (
    <Button
      onPress={props.onPress}
      disabled={props.disabled}
      width={"auto"}
      contentSeparator={5}
      bgColor={colors.white}
      bordered={{ width: 2, color: colors.success + "33" }}
      radius={sizes.radius.lg}
      icon={{ name: "plus", size: 18 }}
      title={{
        size: "md",
        weight: "bold",
        value: props?.title || strings.add,
        color: colors.success,
      }}
      style={{
        paddingHorizontal: sizes.space,
        alignSelf: "flex-end",
        marginBottom: 20,
      }}
    />
  );
}
